export const loadingAppMessage = "Loading app...";
export const loadingMessage = "Loading...";
export const loggingOffMessage = "Logging off...";
export const redirectingToLoginMessage = "Redirecting to login...";
export const signingYouInMessage = "Signing you in...";
